import { apiRequest } from '@/shared/api';

import type {
  MarkResultSeenPayload,
  PendingResult,
  ResultSeenResult,
} from '../model/types';

export function fetchPendingResult(): Promise<PendingResult> {
  return apiRequest<PendingResult>('/results/pending');
}

export function markResultSeen(
  payload: MarkResultSeenPayload,
): Promise<ResultSeenResult> {
  return apiRequest<ResultSeenResult>('/results/seen', {
    method: 'POST',
    body: payload,
  });
}
